import React from 'react';
import { IoMdTrash } from 'react-icons/io';
import PropTypes from 'prop-types';

// Styles
import { ListStyled, ListItem } from '../../../css/styles/list';

const listItem = props => {
  return props.maintenanceTechnicalReports.map(item => (
    <ListItem
      color="#011826"
      strongColor="#fff"
      key={item.uuid}
      onClick={() => props.onEdit(item)}
    >
      <div className="info">
        <div>
          <strong className="title">Descrição:</strong>
          <strong>{item.technicalreport?.description}</strong>
        </div>

        <div>
          <strong className="title">Data:</strong>
          <strong>
            {new Date(
              item.technicalreport?.updateAt ||
                item.technicalreport?.createdAt ||
                ''
            ).toLocaleString('pt-BR', {
              timeZone: 'UTC',
            })}
          </strong>
        </div>

        <div>
          <strong className="title">VEÍCULO:</strong>
          <strong>{item.technicalreport?.equipment?.code}</strong>
        </div>
        <div>
          <strong className="title">EMPREGADO:</strong>
          <strong>{item.technicalreport?.employee?.name}</strong>
        </div>
      </div>

      <button
        type="button"
        onClick={e => {
          e.stopPropagation();
          props.onDelete(item);
        }}
        className="delete"
      >
        <IoMdTrash size={20} color="#bf1523" />
      </button>
    </ListItem>
  ));
};

function MaintenanceTechnicalList(props) {
  const { maintenanceTechnicalReports } = props;

  return (
    <>
      {maintenanceTechnicalReports && maintenanceTechnicalReports.length > 0 ? (
        <ListStyled>{listItem(props)}</ListStyled>
      ) : (
        <strong>LISTA VAZIA</strong>
      )}
    </>
  );
}

MaintenanceTechnicalList.propTypes = {
  maintenanceEmployees: PropTypes.arrayOf(
    PropTypes.shape({
      uuid: PropTypes.string,
      start: PropTypes.string,
      end: PropTypes.string,
    })
  ),
};

MaintenanceTechnicalList.defaultProps = {
  maintenanceEmployees: [],
};

export default MaintenanceTechnicalList;
